<template>
  <div style="height: 100%">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <div class="title">
        <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      </div>
      <div style="margin-top: 22px; padding-bottom: 24px">
        <el-form label-width="120px">
          <el-form-item label="上传客服图片">
            <upload-picture
              :limit="1000000"
              :isCustomer="1"
              :list="fileList"
              @changeImage="changeImage"
            />
            <div class="messageI">
              图片尺寸：建议上传750px*1334px，每张上传大小不得超过5M,支持jpg、jpeg、png格式
            </div>
          </el-form-item>
          <el-form-item label="显示二维码方式">
            <el-input
              v-model="type"
              style="width: 232px"
              size="small"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="display: flex" class="bottom-but">
      <el-button type="info" @click="back">返回</el-button>
      <el-button type="primary" @click="submit">确认</el-button>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import uploadPicture from '@/components/upload/dragpicturew.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    uploadPicture
  },
  data () {
    return {
      type: '随机更换',
      fileList: [],
      title: '添加角色',
      isEdit: false,
      isRole: false,
      name: '',
      dataList: {
        list: [
          { title: '系统管理', path: '', type: '0' },
          { title: '客服设置', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '客服设置', path: '', type: '0' },
        ]
      },
      searchForm: {
        name: '', // 	否 	string 	商品名称
        goodsNo: '', // 	否 	string 	商品编号
        categoryId: '', // 	否 	int 	类目id（数据来源：接口 - /order/comm/commodityCategory/commList）
        brandId: '', // 	否 	int 	品牌id（数据来源：接口 - /order/comm/brand/list?pageNo=1&pageSize=999）
        goodsType: '', // 	否 	int 	类型（1：普通商品；2：虚拟商品；3：赠品；字典：goods_type）
        status: '', // 	否 	int 	状态（字典：sale_status）
        orderBy: '', // 	否 	int 	排序（0价格；1可用库存；2总销量）
        orderByType: '' // 	否 	int 	排序方式（0正序；1倒序）
      },
      value1: [],
      brandList: [],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '用户名称', prop: 'username', minWidth: '120' },
        { label: '角色名称', prop: 'roleName', minWidth: '120' },
        { label: 'IP地址', prop: 'clientIp', minWidth: '220' },
        { label: '登录时间', prop: 'loginTime', minWidth: '100' },
        {
          label: '操作',
          minWidth: '120',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.deleteFn('one', scope.row.id) }}>删除</span>
              </div >
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      recordList: [],
      selection: []
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    submit () {
      let arr = []
      this.fileList.forEach(item => {
        arr.push(item.url)
      })
      let data = {
        image: arr
      }
      this.axios.post('/users/addPsCustomer', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.getInfo()
          }
        })
    },
    changeImage (val) {
      console.log(val)
      this.fileList = val
    },
    onMultipleSelection (e) {
      this.selection = e;
    },
    handleSizeChange (e) {
      this.page.pageNo = 1;
      this.page.pageSize = e;
      this.getLoginRecord()
    },
    handleCurrentChange (e) {
      this.page.pageNo = e;
      this.getLoginRecord()
    },
    getInfo () {
      this.axios.post('/users/getPsCustomer', {})
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            console.log(res.data.images)
            let arr = []
            res.data.images.forEach(item => {
              let obj = {
                url: item,
              }
              arr.push(obj)
            })
            this.fileList = arr
          }
        })
    },
    add () {
      this.isEdit = true
      this.title = '添加角色'
    },
    edit () {
      this.isEdit = true
      this.title = '编辑角色'
    },
    deleteFn (type, id) {
      let data = {
        ids: []
      }
      if (type == 'one') {
        data.ids = [id]
      }
      if (type == 'all') {
        if (this.selection.length == 0) {
          return this.$message.warning('无删除选项')
        }
        let ids = this.selection.map(item => {
          return item.id
        })
        data.ids = ids;
      }
      this.$confirm('是否确认删除？删除后不可恢复数据！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.axios.post('/loginRecords/delete', data)
          .then(res => {
            console.log(res)
            this.page.pageNo = 1;
            this.getLoginRecord()
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-tree-node__content {
  display: flex;
  align-items: center;
  height: 55px;
  cursor: pointer;
}
// 自定义图标中隐藏自带箭头
::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
  position: absolute;
  opacity: 0;
}
.messageI {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  // margin-top: 7px;
  color: #909099;
}
.bottom-but {
  margin-top: 18px;
  text-align: left;

  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-button + .el-button {
    margin-left: 32px;
  }
}
::v-deep .el-tree-node__content {
  position: relative;
}
::v-deep .el-input--prefix .el-input__inner {
  padding-left: 80px;
}
::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}
::v-deep .el-dialog__header {
  text-align: left;
  border-bottom: none;
}
.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}
.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}
.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
}
.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;
      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>

